import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import TabPanel1 from "./TabPanel1";
import TabPanel2 from "./TabPanel2";
import TabPanel3 from "./TabPanel3";
import TabPanel4 from "./TabPanel4";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import { vehicleActions } from "../../service/vehicle.actions";

function TabPanel(props: any) {
  const { children, value, index } = props;
  return <div>{value === index && <h1>{children}</h1>}</div>;
}

const VehicleModal = ({
  tenant,
  closeModal,
  data,
  childToParent,
  tireType,
}: any) => {
  const [loading, setIsLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [editVehicle, setEditVehicle] = useState<any>({
    currentTireType: data.currentTireType,
    keyless: data.keyless,
    connected: data.connected,
    imeiSecondary: data.imeiSecondary ? data.imeiSecondary : "",
    kmMaintenance: data.kmMaintenance !== undefined ? data.kmMaintenance : "",
    maintenancePeriod:
      data.maintenancePeriod !== undefined ? data.maintenancePeriod : "",
  });

  const { t } = useTranslation(["operation"]);

  const cancel = () => {
    closeModal(false);
  };

  const handleTabs = (event: React.SyntheticEvent, val: number) => {
    setTab(val);
  };

  return (
    <Dialog
      open={true}
      maxWidth={"lg"}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      <Box sx={{ borderBottom: 3, borderColor: "divider" }}>
        <Tabs
          value={tab}
          onChange={handleTabs}
          className="vehicle-modal-header"
          sx={{
            ".MuiTabs-indicator": { backgroundColor: "#C8017D!important" },
          }}
          variant="fullWidth"
        >
          <Tab label={t("vehicle.vehicleModal.label1")}></Tab>
          <Tab label={t("vehicle.vehicleModal.label2")}></Tab>
          <Tab label={t("vehicle.vehicleModal.label3")}></Tab>
          <Tab label={t("vehicle.vehicleModal.label4")}></Tab>
        </Tabs>
      </Box>
      <Grid className="vehicle-modal-content">
        <TabPanel value={tab} index={0}>
          <TabPanel1
            data={data}
            setEditVehicle={setEditVehicle}
            editVehicle={editVehicle}
            tireType={tireType}
          />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <TabPanel2 data={data} editVehicle={editVehicle} />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <TabPanel3 data={data} />
        </TabPanel>
        <TabPanel value={tab} index={3}>
          <TabPanel4 data={data} />
        </TabPanel>
      </Grid>
      <Grid className="footer-container">
        <Grid item xs={6} className="vehicle-modal-footer">
          <Button variant="outlined" size="medium" onClick={cancel}>
            <Typography variant="h6" color="accent.main">
              {t("actionButtons.cancel")}
            </Typography>
          </Button>
        </Grid>
      </Grid>
      {loading && <CustomLoader loading={loading} />}
    </Dialog>
  );
};

export default VehicleModal;
